<template>
  <v-toolbar
    color="primary"
    fixed
    dark
    app
    >
    <v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
    <v-toolbar-title class="ml-0 pl-3">
      <v-chip :color="(currentUser.negative?`light-red darken-2`:`cyan darken-3`)" text-color="white">
        موجودی حساب:
        {{currentUser.balance}}
      </v-chip>
    </v-toolbar-title>
<!--      <v-text-field
        flat
        solo-inverted
        prepend-icon="search"
        label="Search"
        class="hidden-sm-and-down"
        >
      </v-text-field>-->
      <v-spacer></v-spacer>
      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
        <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span v-if="counter !== 0" slot="badge">{{toPersianDigit(counter,false)}}</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
        </v-btn>
        <notification-list @change="changeCounter"></notification-list>
      </v-menu>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
            <v-icon>account_circle</v-icon>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
  </v-toolbar>
</template>
<script>
import NotificationList from '@/components/widgets/list/NotificationList';
import Util from '@/util';
export default {
  name: 'app-toolbar',
  components: {
    NotificationList
  },
  props: {
    currentUser: Object
  },
  data: () => ({
    counter: 0,
    items: [
      {
        icon: 'settings',
        href: '#/pages/profile_setting/setting',
        title: 'تنظیمات کاربری',
        click: (e) => {

        }
      },
      {
        icon: 'exit_to_app',
        href: '#',
        title: 'خروج',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  methods: {
    changeCounter (c) {
      this.counter = c;
    },
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    toPersianDigit: function (input, toEnglish) {
      if (typeof input !== 'string') {
        input = input.toString();
      }
      let dg = [
        ['۰', '0'],
        ['۱', '1'],
        ['۲', '2'],
        ['۳', '3'],
        ['۴', '4'],
        ['۵', '5'],
        ['۶', '6'],
        ['۷', '7'],
        ['۸', '8'],
        ['۹', '9']
      ];
      if (typeof toEnglish === 'undefined') {
        toEnglish = false;
      }
      if (toEnglish) {
        for (let i = 0; i <= 9; i++) {
          input = input.replace(new RegExp(dg[i][0], 'g'), dg[i][1]);
        }
        return input;
      }
      for (let i = 0; i <= 9; i++) {
        input = input.replace(new RegExp(dg[i][1], 'g'), dg[i][0]);
      }
      return input;
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue